import { infoWindow } from "./info-window";
import { filterMarker, fitAllMarkers } from "./filter-markers";

function sideLinksClick(map) {
  $(".store-locations li a").on("click", function(e) {
    e.preventDefault();
    const $this = $(this);
    const $ul = $this.closest("ul");
    const thisText = $this.text().toLowerCase();
    const $storeLocations = $(".store-locations");

    $(".stores .search-stores p").hide();
    const filteredLocationMarkers = filterMarker(thisText);

    // Check if any markers are present and fit them to the bounds or show the city/state
    fitAllMarkers(map, filteredLocationMarkers);

    if ($this.data("target")) {
      infoWindow(map, $this.data("target"));
    } else {
      $("html,body").animate({
        scrollTop: $storeLocations.offset().top - $(".header").outerHeight()
      });
      $this.parent().addClass("active").siblings().addClass("hide");
    }
  });

  const $storeLocations = $(".store-locations");

  $storeLocations.find("h2").on("click", function() {
    const $this = $(this);
    $this.closest(".active").removeClass("active").siblings().removeClass("hide");
    const thisText = $this.closest(".active").find("li:eq(0) > h2").text().toLowerCase();
    const filteredLocationMarkers = filterMarker(thisText);
    if (filteredLocationMarkers.length > 0 && thisText.length) {
      fitAllMarkers(map, filteredLocationMarkers);
    } else {
      fitAllMarkers(map, mapMarkers);
    }
  });

  const $storeResults = $(".store-results");
  $storeResults.on("click", "h2", function() {
    const $locations = $(".store-locations");
    $storeResults.hide();
    $locations.show();
    $locations.find(".active, .hide").removeClass("active hide");
    fitAllMarkers(map, mapMarkers);
  });
}

module.exports = {
  sideLinksClick
};



// WEBPACK FOOTER //
// ../assets/js/map/side-links.js